import { actions as CommonActions } from '../../actions/common/common';
import { actions as JobActions } from '../../actions/jobs/jobs';
import { actions as MemberActions } from '../../actions/members/members';
import { actions as TagActions } from '../../actions/common/tags2';

export default function common( state, action ) {
    if( !state ) {
        return {
            slotData: [],
            networks: [],
            sliderData: [],
            url: '',
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case CommonActions.SET_SLOT_DATA: return setSlotData( newState, action );
        case CommonActions.SET_SLIDER_DATA: return setSliderData( newState, action );
        case CommonActions.SET_NETWORKS: return setNetworks( newState, action.networks );
        case JobActions.SET_SEARCH_INITIAL_VALUES: return setSearchValues( newState, action.options );
        case MemberActions.SET_SEARCH_INITIAL_VALUES: return setSearchValues( newState, action.options );
        case MemberActions.RESET_SEARCH_INITIAL_VALUES: return resetSearchInitialValues( newState );
        case CommonActions.SET_ALL_PROFILES: return getAllProfiles( newState, action.profiles );
        case TagActions.SET_TAGS: return setTags( newState, action.tags );
        default: return state;
    }
}

function getAllProfiles( newState, profiles ) {

    newState.profiles = [...profiles];
    return newState;
}

function setSlotData( newState, action ) {
    const _slotData = [ ...newState.slotData ];

    const present = _slotData.filter( ( slot ) => { return slot.id === action.slotData.id } );

    if( present.length < 1 ){
        if( Array.isArray(action.slotData) ) {
            _slotData.push( action.slotData[0] );
        } else {
            _slotData.push( action.slotData );
        }

        newState.slotData = _slotData;

    }

    return newState;
}

function setSliderData( newState, action ) {
    newState.sliderData = action.slotData;

    return newState;
}

function setNetworks( newState, networks ) {
    newState.networks = networks;

    return newState;
}

function setSearchValues( newState, options ) {
    newState.initialValues = options;

    return newState;
}

function resetSearchInitialValues( newState ) {
    newState.initialValues = {};

    return newState;
}

function setTags( newState, tags ) {
     newState.tags = tags;
     return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/common/common.js